module.exports = __webpack_public_path__ + "img/Final Model V6.3bbcfa29.jpg";